// File: src/App.js
// License: All Rights Reserved
// Copyright (c) 2024 Byron Korir

import React, { useContext } from 'react';
import LoadingComponent from '../components/LoadingComponent';
import { ReceiptContext } from '../context/ReceiptContext';
import UpdateReceipt from './UpdateReceipt';
import DeleteReceipt from './DeleteReceipt';
import { AuthContext } from '../context/AuthContext';

const Receipts = () => {
  const {receipts,loading} = useContext(ReceiptContext)
  const {currentUser} = useContext(AuthContext)

  return (
    <div className="container-fluid pb-4" style={{backgroundColor:'rgb(8, 50, 32,1)',minHeight:'100%'}}>
      <h2 className="text-center pt-4 mb-4" style={{ fontFamily: 'inknut antiqua', fontWeight: 'bold', color: 'wheat' }}>
        Receipts
      </h2>
      
      

      {loading ? (
        <LoadingComponent loadingText={'Loading ....'}/>
      ) : receipts && receipts.length === 0 ? (
        <div className="alert alert-info" role="alert">
          No Receipts found.
        </div>
      ) : (
        <div className="table-responsive bg-white bg-opacity-75 rounded">
          <table className="table table-striped rounded table-hover text-center" >
            <thead>
              <tr className='text-success fs-5' >
                <th>Id</th>
                <th>Name</th>
                <th>email</th>
                <th>Package</th>
                <th>Amount</th>
                <th>Date</th>
                <th>Action</th>
              
              </tr>
            </thead>
            <tbody>
            {Array.isArray(receipts) && receipts.length > 0 && receipts.map((receipt) => (
               <tr key={receipt?.id} >
                  <td style={{ fontSize: '0.85em' }}>{receipt?.id}</td>
                  <td style={{ fontSize: '0.85em' }}>{receipt?.client_name}</td>
                  <td style={{ fontSize: '0.85em' }}><a href={`mailto:${receipt?.client_email}`}>{receipt?.client_email}</a></td>
                  <td style={{ fontSize: '0.85em' }}>{receipt?.package}</td>
                  <td style={{ fontSize: '0.85em' }}>{receipt?.amount?.toLocaleString()} $</td>
                  <td style={{ fontSize: '0.85em' }}>{receipt?.received_date}</td>
                  {(currentUser?.position === 'ADMIN' || currentUser?.id === receipt?.staff_id) ?
                  (<td 
                    style={{ fontSize: '0.85em' }}>
                       <UpdateReceipt receipt={receipt}/>
                       <DeleteReceipt receipt={receipt}/>
                       </td>
                  )
                :
                (
                  <td>
                    <button className='btn btn-sm btn-secondary'>None</button>
                  </td>
                )}
                  
               </tr>
               ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Receipts;
